import { render, staticRenderFns } from "./son1.vue?vue&type=template&id=433fc9c2&scoped=true"
import script from "./son1.vue?vue&type=script&lang=js"
export * from "./son1.vue?vue&type=script&lang=js"
import style0 from "./son1.vue?vue&type=style&index=0&id=433fc9c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433fc9c2",
  null
  
)

export default component.exports